import { render, staticRenderFns } from "./RestitutionFormView.vue?vue&type=template&id=8207f96c&scoped=true&"
import script from "./RestitutionFormView.vue?vue&type=script&lang=js&"
export * from "./RestitutionFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8207f96c",
  null
  
)

export default component.exports